import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconPayment(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M15 17a1 1 0 0 0-1-1h-4a1 1 0 1 0 0 2h4a1 1 0 0 0 1-1ZM18 13a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1 5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v4h1a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-4H4a3 3 0 0 1-3-3V5Zm16 3v1H8a3 3 0 0 0-3 3v1H4a1 1 0 0 1-1-1V8h14Zm0-2V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v1h14Zm-9 5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1H8Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
